// extracted by mini-css-extract-plugin
export default {"header__dropdown":"header__dropdown--JcvhT","headerDropdown":"header__dropdown--JcvhT","absences__table":"absences__table--xYMSX","absencesTable":"absences__table--xYMSX"};